"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _LanguageSelectorComponent = require("./LanguageSelectorComponent");
var _regionFormActions = require("../../redux/actions/regionFormActions");
var mapStateToProps = function mapStateToProps(state) {
  return {
    isAuthenticated: state.auth.isAuthenticated
  };
};
var mapDispatchToProps = {
  setNewLanguage: _regionFormActions.setUserRegionConfig
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_LanguageSelectorComponent.LanguageSelectorComponent);